import {getCountryList} from "@/api/api";

export default {
    watch: {
        '$i18n.locale'() {
            // 检查是否已经加载过国家列表，如果是，则不重新加载
            if (this.countryOptions.length > 0) {
                this.translateCountryOptions();
                return;
            }

            this.fetchCountryOptions();
        },
    },
    data() {
        return {
            countryOptions: [],
            countriesLoaded: false,
            countryData: [],
        };
    },

    methods: {
        async fetchCountryOptions(params = {}) {
            try {
                const result = await getCountryList(params);
                const countryList = result.data || result;
                this.countryData = countryList;
                this.countryOptions = countryList.map(country => {
                    let label = country.name;
                    let code = country.code || country.country_code || country.code2;
                    if (code) {
                        try {
                            const translatedLabel = this.$t(`countries.${code}`);
                            if (translatedLabel !== `countries.${code}`) {
                                label = translatedLabel;
                            }
                        } catch (e) {
                        // ignore
                        }
                    }
                    let regexStr = country.postcode || country.postal_code_regex || country.postalCodeRegex || country.postal_code_pattern || '';
                    if (regexStr && typeof regexStr === 'string') {
                        regexStr = regexStr.replace(/^["']|["']$/g, '');
                    }
                    return {
                        value: country.id,
                        code: code,
                        label: label,
                        postalCodeRegex: regexStr,
                        postalCodeExample: country.postal_code_example || country.postalCodeExample || ''
                    };
                });
                this.countryOptions.sort((a, b) => a.label.localeCompare(b.label));
                this.countriesLoaded = true;
            } catch (error) {
                this.countryOptions = [];
                this.countriesLoaded = true;
            }
        },
        translateCountryOptions() {
            // 仅在语言改变时重新翻译国家列表的标签
            this.countryOptions.forEach(option => {
                try {
                    if (option.code) {
                        // 尝试使用原始代码查找翻译
                        const translatedLabel = this.$t(`countries.${option.code}`);
                        // 如果翻译结果不是 "countries.xxx"，使用翻译结果
                        if (translatedLabel !== `countries.${option.code}`) {
                            option.label = translatedLabel;
                        }
                    }
                } catch (e) {
                    // 如果翻译失败，使用默认标签
                }
            });
            // 重新按照国家名称字母顺序排序
            this.countryOptions.sort((a, b) => a.label.localeCompare(b.label));
        },

        validatePostalCode(countryCode, postalCode) {
            if (!countryCode || !postalCode) {
                return { valid: true, message: '' };
            }
            const normalizedCountryCode = countryCode.toUpperCase();
            const country = this.countryOptions.find(c => c.code && c.code.toUpperCase() === normalizedCountryCode);
            if (!country) {
                return { valid: true, message: '' };
            }
            if (!country.postalCodeRegex) {
                return { valid: true, message: '' };
            }
            try {
                const regex = new RegExp(country.postalCodeRegex);
                const isValid = regex.test(postalCode);
                if (!isValid) {
                    let message = this.$t('MemberRegistrationReview.invalidPostCodeFormat');
                    if (country.postalCodeExample) {
                        message += this.$t('MemberRegistrationReview.postCodeExample').replace('{example}', country.postalCodeExample);
                    }
                    return { valid: false, message };
                }
                return { valid: true, message: '' };
            } catch (e) {
                return { valid: true, message: '' };
            }
        },
    },
};